import { relativePath } from '@/functions/redirectToRelativePath';

export class UrlBuilder {
  private domain: string;
  private cityDomain: string | null = null;
  private queryString: string = '';
  private hash: string = '';

  constructor(domain: string) {
    this.domain = domain;
  }

  public setCityDomain(cityDomain: string | null) {
    this.cityDomain = cityDomain;
    return this;
  }

  public setQueryString(queryString: string) {
    this.queryString = queryString;
    return this;
  }

  public setHash(hash: string) {
    this.hash = hash;
    return this;
  }

  public build() {
    const paths: string[] = [];
    if (this.cityDomain) {
      paths.push(this.cityDomain);
    }
    if (this.queryString) {
      paths.push('list');
    }
    const path = paths.join('/');
    return relativePath(
      `/${path}${this.queryString ? `?${this.queryString}` : ''}${this.hash ? `#${this.hash}` : ''}`,
      this.domain
    );
  }
}
